import { useEffect } from "react";
import URLService from "../service/urlService";

function RedirectToArrivalOperator() {
  useEffect(() => {
    window.location.href = URLService.generateRedirectUrl(
      window._env_.REACT_APP_ARRIVAL_OPERATOR_URL
    );
  }, []);

  return null;
}

export default RedirectToArrivalOperator;
